export * from './interpolate';
